export type DictationSource = "note-composer" | "note-editor";

export interface DictationSaveReport {
    edited: boolean;
    dictatedCharacters: number;
    savedCharacters: number;
}

export interface DictationSaveTracker {
    recordDictated: (value: string) => void;
    recordSaved: (value: string) => void;
}

export const createDictationSaveTracker = (
    report: (saveReport: DictationSaveReport) => void,
): DictationSaveTracker => {
    let dictated: string | null = null;
    return {
        recordDictated: value => {
            dictated = value;
        },
        recordSaved: value => {
            if (dictated === null) {
                return;
            }
            report({
                edited: dictated.trim() !== value.trim(),
                dictatedCharacters: dictated.length,
                savedCharacters: value.length,
            });
            dictated = null;
        },
    };
};
